import { TopConfig } from '../context/ConfigContext';

export const getEngagementServiceConfig = (topConfig: TopConfig) => {
    const { engagement: engagementServiceConfig } = topConfig.services;
    const { url } = engagementServiceConfig;

    if (!url) {
        throw new Error('Engagement service: Url not defined');
    }

    return engagementServiceConfig;
};
